module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/2-bc08d192c5476fda4a698d2fde6d5195.svg";